import React from 'react';
import Container from 'react-bootstrap/Container';

const OurMissions = () => {
    return (
      <div className="section-separator">
        <Container className="px-4">
          <div className="my-5">
            <h2 className="display-5 fw-bold text-white text-center fw-bold about-us-page-text mb-3">
              A NOSSA MISSÃO!
            </h2>
            <div className="col-lg-5 mx-auto">
              <p className="mb-4 text-justify about-us-page-text lead">
                Acreditamos que a transformação começa com o querer fazer melhor
                e com oportunidades. Muitos jovens têm vontade de fazer a
                diferença, mas nem sempre têm os recursos ou o conhecimento para
                agir. A nossa missão é preencher essa lacuna, oferecendo-lhes
                acesso a experiências que desenvolvem as suas competências
                sociais, cívicas e profissionais, preparando-os para um papel
                mais ativo e informado na sociedade.
              </p>
              <p className="mb-4 text-justify about-us-page-text lead">
                Trabalhamos para uma juventude detentora da sua liberdade de
                expressão, autónomos no seu pensar, conscientes nas suas
                decisões que influenciarão sim, o futuro deles, mas também o do
                bem comum.
              </p>
              <p className="mb-4 text-justify about-us-page-text lead">
                A mudança começa em e com cada um de nós!
              </p>
            </div>
          </div>
        </Container>
      </div>
    );
}

export default OurMissions;